import React from 'react';
import PropTypes from 'prop-types';
import View from '@loggi/ui/components/view';
import Col from '@loggi/ui/components/col';
import Text from '@loggi/ui/components/text';
import Icon from '@loggi/ui/components/icon';
import icons from '@loggi/ui/components/utils/icons';
import colors from '@loggi/ui/components/utils/colors';
import MainView from 'shared/main-view/main-view.component';
import {
  DELIVERY_CONFIRMATION_MESSAGE,
  DELIVERY_CONFIRMATION_RECEIVED,
  DELIVERY_CONFIRMATION_RECEIVED_TEXT,
  DELIVERY_CONFIRMATION_TEXT
} from './confirm-delivery.constants';

import styles from '../confirm-delivery.styles.scss';

export default function ConfirmDeliveryMain({ recipientName, receivedBy }) {
  return (
    <MainView>
      <View
        flex
        flexDirection="column"
        flexGrow="1"
        gutter={{
          left: 'double',
          right: 'double',
          bottom: 'double'
        }}
        justifyContent="between"
      >
        <Text className={styles.newConfirmDelivery} color={colors.type.DARK}>
          {`${recipientName} ${DELIVERY_CONFIRMATION_MESSAGE}`}
        </Text>
        <Col
          flex
          flexDirection="row"
          alignItems="center"
          gutter={{
            top: 'double',
            right: 'double'
          }}
        >
          <Col className={styles.confirmDeliveryIcon}>
            <Icon
              color={colors.type.ACTIVE}
              type={icons.type.SHORT_ARROW_RIGHT}
            />
          </Col>
          <Col flexDirection="column">
            <Text color={colors.type.DARK}>
              {DELIVERY_CONFIRMATION_RECEIVED}
              <Text color={colors.type.ACTIVE}>{receivedBy}</Text>.
              <Text color={colors.type.DARK}>
                {DELIVERY_CONFIRMATION_RECEIVED_TEXT}
              </Text>
            </Text>
          </Col>
        </Col>
        <Col
          flex
          flexDirection="row"
          alignItems="center"
          gutter={{
            top: 'double',
            right: 'double'
          }}
        >
          <Col className={styles.confirmDeliveryIcon}>
            <Icon
              color={colors.type.ACTIVE}
              type={icons.type.SHORT_ARROW_RIGHT}
            />
          </Col>
          <Col flexDirection="column">
            <Text color={colors.type.DARK}>{DELIVERY_CONFIRMATION_TEXT}</Text>
          </Col>
        </Col>
      </View>
    </MainView>
  );
}

ConfirmDeliveryMain.displayName = 'ConfirmDeliveryMain';

ConfirmDeliveryMain.propTypes = {
  recipientName: PropTypes.string.isRequired,
  receivedBy: PropTypes.string.isRequired
};
